import React from 'react';

export const AVAILABILITY_OPTIONS = [
  { value: 'available', label: 'Available' },
  { value: 'sold_out_today', label: 'Sold out for today' },
  { value: 'sold_out', label: 'Sold out' },
];

const SOURCE_LABELS = { category: 'category', subcategory: 'sub category' };

// Availability of a product / category / sub-category: visible on the menu but not orderable
// while sold out. Separate from the "Enabled" toggle next to it, which hides the item entirely.
// `inheritedFrom` ('category' | 'subcategory') is set on a product that is sold out only because
// its category or sub-category is - changing the product's own state wouldn't bring it back.
const AvailabilitySelect = ({ value, onChange, inheritedFrom }) => (
  <div className="availabilityCell">
    <select
      className={`form-select form-select-sm availabilitySelect availability-${value}`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label="Availability"
    >
      {AVAILABILITY_OPTIONS.map((opt) => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
    {inheritedFrom && (
      <div className="availabilityHint">Sold out via {SOURCE_LABELS[inheritedFrom] || inheritedFrom}</div>
    )}
  </div>
);

export default AvailabilitySelect;
